const initialState = {
    filteredUsers: [],
    workspaces: [],
    workspaceID: null,
    workspaceInfo: null,
    workspaceByRole: null,
    error: null,
    createError: null
}

const workspaceReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'CREATE_WORKSPACE':
            return {
                ...state,
                workspaces: [state.workspaces, action.payload]
            }
        case 'CREATE_WORKSPACE_FAIL':
            return {
                ...state,
                createError: action.payload
            }
        case 'CLEAR_WORKSPACE_ERROR':
            return {
                ...state,
                createError: null
            }
        case 'GET_WORKSPACES':
            return {
                ...state,
                workspaces: action.payload.data
            }
        case 'GET_SPECIFICWORKSPACE':
            return {
                ...state,
                workspaceInfo: action.payload,
                workspaceID: action.payload._id
            }
        case 'GET_WORKSPACEBYROLE':
            return {
                ...state,
                workspaceByRole: action.payload
            }
        case 'LOGIN_WORKSPACE_REQUEST':
            return {
                ...state,
            }
        case 'LOGIN_WORKSPACE_SUCCESS':
            return {
                ...state,
                workspaceInfo: action.payload.name,
                workspaceID: action.payload._id
            }
        case 'LOGIN_WORKSPACE_FAIL':
            return {
                ...state,
                error: action.payload
            }
        case 'GET_FILTEREDUSERS':
            return {
                ...state,
                filteredUsers: action.payload
            }
        case 'DELETE_WORKSPACE':
            return {
                ...state,
                workspaces: action.payload
            }
        case 'UPDATE_CURRENT_WORKSPACE':
            return {
                ...state,
                workspaceInfo: action.payload
            }
        default:
            return state;
    }
}


export default workspaceReducer;